import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { message } from "antd";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getCourses } from "../../redux/actions/admin/courseAction";
import {
  addStudent,
  getBatchStudents,
} from "../../redux/actions/admin/studentAction";
import PageTitle from "../../Components/PageTitle";

const AddEnrollStudentBatch = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { batchId, name } = location.state || {};
  const { courses, loading, error } = useSelector((state) => state.courses);
  const [studentCourseId, setStudentCourseId] = useState("");
  const [studentName, setStudentName] = useState("");
  const [studentEmail, setStudentEmail] = useState("");
  const [studentPhone, setStudentPhone] = useState("");
  const [studentCourse, setStudentCourse] = useState("");
  const [studentCourseFees, setStudentCourseFees] = useState("");
  const [studentFees, setStudentFees] = useState("");
  const [teachersNotes, setTeachersNotes] = useState("");
  const [parentName, setParentName] = useState("");
  const [parentEmail, setParentEmail] = useState("");
  const [parentPhone, setParentPhone] = useState("");

  // Handle Student Course
  const handleChangeStudentCourse = (event) => {
    const selectedCourseName = event.target.value;
    setStudentCourse(selectedCourseName);
    const selectedCourse = courses.find(
      (course) => course.name === selectedCourseName
    );
    if (selectedCourse) {
      setStudentCourseFees(selectedCourse.fees);
      setStudentCourseId(selectedCourse._id);
    }
  };

  // Fetch all courses
  useEffect(() => {
    dispatch(getCourses());
  }, [dispatch]);

  useEffect(() => {
    if (courses) {
      setStudentCourse(courses);
    }
  }, [courses]);
  // Add Institute Student
  const handleSubmit = async (e) => {
    e.preventDefault();
    const studentData = {
      courseId: studentCourseId,
      batchId,
      name: studentName,
      email: studentEmail,
      phone: studentPhone,
      parentName,
      parentPhone,
      parentEmail,
      feesDeposit: studentFees,
      courseFees: studentCourseFees,
      teachersNotes,
    };
    await dispatch(addStudent(studentData));
    await dispatch(getBatchStudents(batchId));
  };

  const handleStudentFeesChange = (e) => {
    const fees = e.target.value;
    // Allow empty input or a number less than or equal to course fees
    if (fees === "" || parseFloat(fees) <= studentCourseFees) {
      setStudentFees(fees);
    } else {
      message.warning("Student Fees cannot exceed Course Fees.");
    }
  };

  return (
    <>
      <PageTitle
        title="Enroll Students - Admin Panel | Shree Mangalam School"
        description="Easily enroll new students through the Admin Panel of Shree Mangalam School. Add academic details, assign batches, and manage course registrations efficiently."
        url="/admin/enroll/student"
        keywords="student enrollment, admin enroll student, Shree Manglam admission admin, add new student, manage student data, school admission system"
      />
      <Container
        onSubmit={handleSubmit}
        component="form"
        className="form_style border-style"
        maxWidth
      >
        <TextField
          sx={{
            mb: 3,
            "& .MuiInputBase-root": {
              color: "text.secondary",
            },
            fieldset: { borderColor: "rgb(231, 235, 240)" },
          }}
          fullWidth
          id="studentBatch"
          label="Batch & Class Name *"
          name="studentBatch"
          placeholder="Batch & Class Name"
          value={name}
          aria-readonly="true"
          disabled
        />

        <TextField
          sx={{
            mb: 3,
            "& .MuiInputBase-root": {
              color: "text.secondary",
            },
            fieldset: { borderColor: "rgb(231, 235, 240)" },
          }}
          select
          name="studentCourse"
          label="Student Course"
          placeholder="Student Course"
          value={studentCourse}
          onChange={handleChangeStudentCourse}
          fullWidth
          variant="outlined"
        >
          {/* Dropdown options */}
          <MenuItem disabled>Select Course</MenuItem>
          {courses &&
            courses.map((course) => (
              <MenuItem key={course._id} value={course.name}>
                {course.name}
              </MenuItem>
            ))}
        </TextField>

        {/* Displaying Course Fees */}
        <TextField
          sx={{
            mb: 3,
            "& .MuiInputBase-root": {
              color: "text.secondary",
            },
            fieldset: { borderColor: "rgb(231, 235, 240)" },
          }}
          fullWidth
          id="studentCourseFees"
          label="Course Fees *"
          name="studentCourseFees"
          placeholder="Course Fees"
          value={studentCourseFees}
          onChange={(e) => setStudentCourseFees(e.target.value)}
          disabled
        />
        {/* Text fields are now always displayed regardless of email data */}
        <TextField
          sx={{
            mb: 3,
            "& .MuiInputBase-root": {
              color: "text.secondary",
            },
            fieldset: { borderColor: "rgb(231, 235, 240)" },
          }}
          fullWidth
          id="studentName"
          label="Student Name *"
          name="studentName"
          placeholder="Student Name"
          value={studentName}
          onChange={(e) => setStudentName(e.target.value)}
        />
        <TextField
          sx={{
            mb: 3,
            "& .MuiInputBase-root": {
              color: "text.secondary",
            },
            fieldset: { borderColor: "rgb(231, 235, 240)" },
          }}
          fullWidth
          id="studentEmail"
          label="Student Email *"
          name="studentEmail"
          placeholder="Student Email"
          value={studentEmail}
          onChange={(e) => setStudentEmail(e.target.value)}
        />
        <TextField
          sx={{
            mb: 3,
            "& .MuiInputBase-root": {
              color: "text.secondary",
            },
            "& input[type='number']": {
              MozAppearance: "textfield",
              "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                display: "none",
              },
            },
            fieldset: { borderColor: "rgb(231, 235, 240)" },
          }}
          fullWidth
          type="number"
          id="studentPhone"
          label="Student Phone Number *"
          name="studentPhone"
          placeholder="Student Phone Number"
          value={studentPhone}
          onChange={(e) => setStudentPhone(e.target.value)}
        />

        <TextField
          sx={{
            mb: 3,
            "& .MuiInputBase-root": {
              color: "text.secondary",
            },
            "& input[type='number']": {
              MozAppearance: "textfield",
              "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                display: "none",
              },
            },
            fieldset: { borderColor: "rgb(231, 235, 240)" },
          }}
          fullWidth
          id="studentFees"
          label="Student Fees Deposit *"
          name="studentFees"
          type="number"
          placeholder="Student Fees Deposit"
          value={studentFees}
          onChange={handleStudentFeesChange}
        />
        <Typography
          gutterBottom
          variant="h6"
          component="div"
          color="text.secondary"
          sx={{
            fontFamily: "Poppins, sans-serif",
            lineHeight: 1.8,
            letterSpacing: "1.8px",
          }}
        >
          Parents Information{" "}
        </Typography>

        <TextField
          sx={{
            mb: 3,
            mt: 3,
            "& .MuiInputBase-root": {
              color: "text.secondary",
            },
            fieldset: { borderColor: "rgb(231, 235, 240)" },
          }}
          fullWidth
          id="parentName"
          label="Parent Name"
          name="parentName"
          placeholder="Parent Name"
          value={parentName}
          onChange={(e) => setParentName(e.target.value)}
        />

        <TextField
          sx={{
            mb: 3,
            "& .MuiInputBase-root": {
              color: "text.secondary",
            },
            fieldset: { borderColor: "rgb(231, 235, 240)" },
          }}
          fullWidth
          id="parentEmail"
          label="Parent Email"
          name="parentEmail"
          placeholder="Parent Email"
          value={parentEmail}
          onChange={(e) => setParentEmail(e.target.value)}
        />

        <TextField
          sx={{
            mb: 3,
            "& .MuiInputBase-root": {
              color: "text.secondary",
            },
            "& input[type='number']": {
              MozAppearance: "textfield",
              "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                display: "none",
              },
            },
            fieldset: { borderColor: "rgb(231, 235, 240)" },
          }}
          type="number"
          fullWidth
          id="parentPhone"
          label="Parent Phone"
          name="parentPhone"
          placeholder="Parent Phone"
          value={parentPhone}
          onChange={(e) => setParentPhone(e.target.value)}
        />

        <TextField
          sx={{
            mb: 3,
            "& .MuiInputBase-root": {
              color: "text.secondary",
            },
            fieldset: { borderColor: "rgb(231, 235, 240)" },
          }}
          fullWidth
          id="teachersNotes"
          label="Teacher's Notes"
          name="teachersNotes"
          placeholder="Teacher's Notes"
          value={teachersNotes}
          onChange={(e) => setTeachersNotes(e.target.value)}
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          className="courses_desc"
          sx={{
            mt: 3,
            borderRadius: "5px",
            textTransform: "none",
            fontFamily: "Poppins, sans-serif",
            letterSpacing: ".1rem",
          }}
        >
          Add Student
        </Button>
      </Container>
    </>
  );
};

export default AddEnrollStudentBatch;
